<template>
  <div>
    <v-select
        v-model="selectedLanguage"
        :options="this.languages"
        :clear-search-on-select="false"
        :searchable="false"
        :clearable="false"
        append-to-body
        :calculate-position="withPopper"
        label="title">
      <template #option="{code, title, img}">
        <span class="select-option">
          <img :src="img" height="30" /> {{ title }}
        </span>
      </template>
      <template #selected-option="{code, title, img}">
        <span class="select-option">
          <img :src="img" height="30" /> {{ title }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { createPopper } from '@popperjs/core'

Vue.component('v-select', vSelect)
export default {
	name: 'LanguageSelect',
	emits: ['selected'],
  data() {
    return {
      placement: 'top',
      languages: [
        {
          code: 'arabic',
          title: 'Arabic',
          img: "sy.svg"
        },
        {
          code: 'bengali',
          title: 'Bengali',
          img: "bd.svg"
        },
        {
          code: 'dari',
          title: 'Dari',
          img: "af.svg"
        },
        {
          code: 'english',
          title: 'English',
          img: "gb.svg"
        },
        {
          code: 'gujarati',
          title: 'Gujarati',
          img: "in.svg"
        },
        {
          code: 'pashto',
          title: 'Pashto',
          img: "af.svg"
        },
        {
          code: 'polish',
          title: 'Polish',
          img: "pl.svg"
        },
        {
          code: 'punjabi',
          title: 'Punjabi',
          img: "pk.svg"
        },
        {
          code: 'romanian',
          title: 'Romanian',
          img: "ro.svg"
        },
        {
          code: 'ukrainian',
          title: 'Ukrainian',
          img: "ua.svg"
        },
        {
          code: 'urdu',
          title: 'Urdu',
          img: "pk.svg"
        }
      ],
    }
  },
  props: ['language'],
  computed: {
    selectedLanguage: {
      get () {
        return this.languages.find((lang) => lang.code === this.language)
      },
      set(value) {
        this.$emit('updateLanguage', value.code)
      },
    }
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -1],
              },
            },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                  'drop-up',
                  state.placement === 'top'
              )
            },
          },
        ],
      })
      return () => popper.destroy()
    },
  }
}
</script>
<style>
  span.select-option {
    display: flex;
  }
  span.select-option img {
    height: 20px;
    width: auto;
    padding-right: 6px;
  }
  .v-select.vs--single, .v-select.vs--searchable, .v-select.drop-up.vs--open {
    background: #ffffff;
    border: none;
    width: 200px;
    border-radius: 5px;
  }
  .v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
    width: 200px;
  }
  [data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
  }
</style>